import { Checkbox, FormControlLabel } from '@mui/material'
import { Spinner } from 'react-bootstrap'
import { CustomSelect, selectTypes } from 'src/consumer/components/helperComponents'
import { DRUG_ADVICE_TABLE_TYPES, DRUG_ADVICE_TABLE_TYPES_ARRAY } from 'src/consumer/constants'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import PrintSettingFormItemComponent from './settingsComponents/PrintSettingFormItemComponent'

export default function PrescriptionPrintSettings({
  prescriptionViewSettings,
  setPrescriptionViewSettings,
  updatePrescriptionViewSettings,
  saveLoading,
}) {
  function setPdfPrintSettings(evePrev) {
    setPrescriptionViewSettings((prev) => {
      if (typeof evePrev === 'function') {
        return { ...prev, pdfPrintSettings: evePrev(prev?.pdfPrintSettings) }
      }
      return { ...prev, pdfPrintSettings: evePrev }
    })
  }

  function setPaperPrintSettings(evePrev) {
    setPrescriptionViewSettings((prev) => {
      if (typeof evePrev === 'function') {
        return { ...prev, paperPrintSettings: evePrev(prev?.paperPrintSettings) }
      }
      return { ...prev, paperPrintSettings: evePrev }
    })
  }

  return (
    <div
    // style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}
    >
      <div>
        <div>
          <div className="d-flex align-items-center justify-content-between">
            <h5 style={{ marginBottom: '1.25rem', fontSize: '1.55rem' }}>Print Settings</h5>
            <button
              className="btn btn-primary"
              style={{ margin: '0px 0px 26px' }}
              onClick={updatePrescriptionViewSettings}
              disabled={saveLoading}
            >
              Save {saveLoading && <Spinner animation="border" variant="light" size="sm" />}
            </button>
          </div>
          <strong>Preferred Languages</strong>
          <div className="d-flex flex-column gap-1">
            <FormControlLabel
              control={
                <Checkbox
                  checked={(
                    prescriptionViewSettings?.preferredPrescriptionLanguages || []
                  ).includes('en')}
                  onChange={(e) => {
                    setPrescriptionViewSettings((prev) => ({
                      ...prev,
                      preferredPrescriptionLanguages: e.target.checked
                        ? [...(prev?.preferredPrescriptionLanguages || []), 'en']
                        : (prev?.preferredPrescriptionLanguages || []).filter(
                            (lang) => lang !== 'en',
                          ),
                    }))
                  }}
                />
              }
              disabled
              label="English"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={(
                    prescriptionViewSettings?.preferredPrescriptionLanguages || []
                  ).includes('hi')}
                  onChange={(e) => {
                    setPrescriptionViewSettings((prev) => ({
                      ...prev,
                      preferredPrescriptionLanguages: e.target.checked
                        ? [...(prev?.preferredPrescriptionLanguages || []), 'hi']
                        : (prev?.preferredPrescriptionLanguages || []).filter(
                            (lang) => lang !== 'hi',
                          ),
                    }))
                  }}
                />
              }
              label="Hindi"
            />
          </div>
        </div>
        {/* <div>
  <div className="d-flex flex-column gap-1 mt-3">
    <FormControlLabel
      control={
        <Checkbox
          checked={prescriptionViewSettings?.hideEmptyDrugAdviceColumns || false}
          onChange={(e) => {
            setPrescriptionViewSettings((prev) => ({
              ...prev,
              hideEmptyDrugAdviceColumns: e.target.checked,
            }))
          }}
        />
      }
      label="Hide empty columns in Rx"
    />
  </div>
</div> */}
        <div>
          <div className="d-flex flex-column gap-1">
            <FormControlLabel
              control={
                <Checkbox
                  checked={prescriptionViewSettings?.showPatientPhoneOnPrescription || false}
                  onChange={(e) => {
                    setPrescriptionViewSettings((prev) => ({
                      ...prev,
                      showPatientPhoneOnPrescription: e.target.checked,
                    }))
                  }}
                />
              }
              label="Show patient phone number on prescription"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={prescriptionViewSettings?.showPatientAddressOnPrescription || false}
                  onChange={(e) => {
                    setPrescriptionViewSettings((prev) => ({
                      ...prev,
                      showPatientAddressOnPrescription: e.target.checked,
                    }))
                  }}
                />
              }
              label="Show patient address on prescription"
            />
            <div style={{ width: '400px' }}>
              <CustomSelect
                value={prescriptionViewSettings?.drugAdviceTablePrintType}
                label="Drug Table Print Type"
                options={DRUG_ADVICE_TABLE_TYPES_ARRAY}
                getOptionValue={(opn) => opn?.id}
                getOptionLabel={(opn) => opn?.title}
                onChangeEvent={(e) =>
                  setPrescriptionViewSettings((prev) => ({
                    ...prev,
                    drugAdviceTablePrintType: e.target.value,
                  }))
                }
                selectType={selectTypes.string}
                id="drugAdviceTablePrintType"
              />
            </div>
            {DRUG_ADVICE_TABLE_TYPES?.[prescriptionViewSettings?.drugAdviceTablePrintType]
              ?.previewImageId && (
              <img
                style={{ maxWidth: '600px', width: '100%' }}
                src={getImageLink(
                  DRUG_ADVICE_TABLE_TYPES?.[prescriptionViewSettings?.drugAdviceTablePrintType]
                    ?.previewImageId,
                )}
                alt="preview"
              ></img>
            )}
          </div>
        </div>
        <div className="pt-1">
          {/* <div className="d-flex flex-column gap-1">
            <CustomInput
              value={
                getValidNumberFromStringNumber(prescriptionViewSettings?.prescriptionMaxPages) || ''
              }
              type="number"
              label="Max number of printable pages"
              // invalid={
              //   !isValidInteger(
              //     getValidNumberFromStringNumber(
              //       prescriptionViewSettings?.defaultHeaderSettings?.prescriptionMaxPages,
              //     ),
              //   )
              // }
              placeholder="100"
              onChange={(e) => {
                setPrescriptionViewSettings((prev) => ({
                  ...prev,
                  prescriptionMaxPages:
                    getValidNumberFromStringNumber(e.target.value) !== 0
                      ? getValidNumberFromStringNumber(e.target.value)
                      : null,
                }))
              }}
            />
          </div> */}
        </div>
        {/* <div className="pt-1">
          <div className="d-flex flex-column gap-1">
            <CustomSelect
              id="printHeaderType"
              value={prescriptionViewSettings?.defaultHeaderSettings?.printHeaderType}
              label="Print Header Type"
              // invalid={
              //   !isValidInteger(
              //     getValidNumberFromStringNumber(prescriptionViewSettings?.shownHeaderHeight),
              //   )
              // }
              selectType={selectTypes.string}
              options={HEADER_TYPES_ARRAY}
              getOptionValue={(optn) => {
                return optn?.id
              }}
              getOptionLabel={(optn) => {
                return optn?.title
              }}
              onChangeEvent={(e) => {
                setPrescriptionViewSettings((prev) => ({
                  ...prev,
                  defaultHeaderSettings: {
                    ...prev?.defaultHeaderSettings,
                    printHeaderType: e.target.value,
                  },
                }))
              }}
            />
          </div>
        </div>
        <div className="pt-1">
          <div className="d-flex flex-column gap-1">
            <CustomSelect
              id="pdfHeaderType"
              value={prescriptionViewSettings?.defaultHeaderSettings?.pdfHeaderType}
              label="Pdf Header Type"
              // invalid={
              //   !isValidInteger(
              //     getValidNumberFromStringNumber(prescriptionViewSettings?.shownHeaderHeight),
              //   )
              // }
              selectType={selectTypes.string}
              options={HEADER_TYPES_ARRAY}
              getOptionValue={(optn) => {
                return optn?.id
              }}
              getOptionLabel={(optn) => {
                return optn?.title
              }}
              onChangeEvent={(e) => {
                setPrescriptionViewSettings((prev) => ({
                  ...prev,
                  defaultHeaderSettings: {
                    ...prev?.defaultHeaderSettings,
                    pdfHeaderType: e.target.value,
                  },
                }))
              }}
            />
          </div>
        </div>
        <div className="pt-1">
          <div className="d-flex flex-column gap-1">
            <CustomInput
              value={
                getValidNumberFromStringNumber(
                  prescriptionViewSettings?.defaultHeaderSettings?.shownHeaderHeight,
                ) || ''
              }
              type="number"
              label="Default Header Prescription Height"
              // invalid={
              //   !isValidInteger(
              //     getValidNumberFromStringNumber(
              //       prescriptionViewSettings?.defaultHeaderSettings?.shownHeaderHeight,
              //     ),
              //   )
              // }
              placeholder="100"
              onChange={(e) => {
                setPrescriptionViewSettings((prev) => ({
                  ...prev,
                  defaultHeaderSettings: {
                    ...prev?.defaultHeaderSettings,
                    shownHeaderHeight:
                      getValidNumberFromStringNumber(e.target.value) !== 0
                        ? getValidNumberFromStringNumber(e.target.value)
                        : null,
                  },
                }))
              }}
            />
          </div>
        </div> */}

        {/* <PrintSettingFormItemComponent
          printSetting={prescriptionViewSettings?.pdfPrintSettings}
          setPrintSetting={setPdfPrintSettings}
          sectionTitle="Pdf Printing Settings"
        /> */}
        <PrintSettingFormItemComponent
          printSetting={prescriptionViewSettings?.paperPrintSettings}
          setPrintSetting={setPaperPrintSettings}
          sectionTitle="Paper Printing Settings"
        />
      </div>
      {/* <div style={{ borderLeft: '1px solid #00000045' }}></div> */}
    </div>
  )
}
